import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../../../datas/DateUtil";
import { FxmsData } from "../../../datas/FxData";
import { width } from "@mui/system";
import { FaceRetouchingOffSharp } from "@mui/icons-material";
import {DataSelecter} from "./DataSelecter";
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from "@mui/icons-material/Settings";
import IconButton from "@mui/material/Button";

HighchartsMore(Highcharts);

/**
 * 라인 챠트
 * 개발자 : 김영상
 * 개발년원 : 2023.2
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export const FxLineChart = (props) => {

  const { id, fxUiGrp, fxUiGrpItem, editable } = props;
  const [title, setTitle] = useState('')
  const [titleSensor, setTitleSensor] = useState("");
    const [titlePsItem, setTitlePsItem] = useState("");
  //list
  const [sensorList, setSensorList] = useState(props.sensorList)
  const [psItemList, setPsItemList] = useState(props.psItemList)
  //selected
  const [psItem, setPsItem] = useState('');
  const [sensor, setSensor] = useState('');

  const [ranges, setRanges] = useState([]);
  const [averages, setAverages] = useState([]);
  const [intervalId, setIntervalId] = useState(null);

  //chart
    const [yAxis, setYAxis] = useState('')
    const [unit, setUnit] = useState('')
    const [chartType, setChartType] = useState('line')

    const [itemAttr, setItemAttr] = useState([])


    useEffect(() => {
        if(props.item.fxUiDashbItemAttrs){
            if(props.item.fxUiDashbItemAttrs.length > 0){
                setTitle(props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'title').attrVal:'')
                setChartType(props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'chartType') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'chartType').attrVal:'line')
                let tempSensor = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'sensor').attrVal : ''
                let tempPsItem = props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem') ? props.item.fxUiDashbItemAttrs.find(x=>x.attrName == 'psItem').attrVal : ''
                if(tempSensor != ''){
                    handleSensorChange({target:{value:parseInt(tempSensor)}})
                }
                if(tempPsItem != ''){
                    handlePsItemChange({target:{value:tempPsItem}})
                }
                showDatas(parseInt(tempSensor),tempPsItem)

            }
        }

    }, []);


    const showDatas = (sensorId,psId) => {
        FxmsData.GET("fxmsPs/minMaxAgvList", {
            moNo: sensorId,
            psId: psId,
          }).then(res=>{
          let averages = [];
          let ranges = [];
          let result = res.data.datas;
          if (result) {
            for (let obj of result) {
              obj.psDate = DateUtil.makeDate(obj.psDate).getTime();
              ranges.push([obj.psDate, obj.minValue, obj.maxValue]);
              averages.push([obj.psDate, obj.avgValue]);
            }
            setRanges(ranges);
            setAverages(averages);
          } else {
            setTitleSensor(sensor.moName + " 데이터 조회 오류!!");
            setTitlePsItem(psItem.psName + " 데이터 조회 오류!!");
          }
        });


  }
    const getData = (id,name) => {
      if(name === "sensor"){
          showDatas(id,psItem)
      }else if(name === "psItem"){
          showDatas(sensor,id)
      }

  }
    const handleSensorChange = (e) => {
        setSensor(e.target.value)
        setTitleSensor(sensorList.find(x=>x.moNo===e.target.value) ? sensorList.find(x=>x.moNo===e.target.value).moDispName : '' )
        if(psItem != ''){
            if(intervalId){
                clearInterval(intervalId)
            }
            const intId = setInterval(getData.bind(this,e.target.value,'sensor'),5000)
            setIntervalId(intId)
            (e.target.value,'sensor')
        }
    }
    const handlePsItemChange = (e) => {
        setPsItem(e.target.value)
        setTitlePsItem(psItemList.find(x=>x.psId===e.target.value) ? psItemList.find(x=>x.psId===e.target.value).psName : '')
        setUnit(psItemList.find(x=>x.psId===psItem) ? psItemList.find(x=>x.psId===psItem).psUnit:'')
        if(sensor != ''){
            if(intervalId){
                clearInterval(intervalId)
            }
            const intId = setInterval(getData.bind(this,e.target.value,'psItem'),5000)
            setIntervalId(intId)
            getData(e.target.value,'psItem')
        }
    }
    const handleTitleChange = (e) => {
        setTitle(e.target.value)
    }
    const handleChartTypeChange = (e) => {
        setChartType(e.target.value)
    }

    const saveCurrentData = () => {
        let currentData = []
        currentData.push({uiNo:props.item.uiNo,attrName:'title',attrVal:title,attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'psItem',attrVal:psItem + '',attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'sensor',attrVal:sensor + '',attrType:'string'})
        currentData.push({uiNo:props.item.uiNo,attrName:'chartType',attrVal:chartType,attrType:'string'})
        props.save(currentData,props.item.uiNo,props.item.opId)
    }
    const removeItem = () => {
        props.removeItem(props.item.uiNo)
    }
  return (
      <>
          {props.editable ? <DataSelecter mode={'base'} sensorList={sensorList} sensor={sensor} psItem={psItem} psItemList={psItemList} chartType={chartType} handleCloseAndSave={saveCurrentData} handleTitleChange={handleTitleChange} handleSensorChange={handleSensorChange} handlePsItemChange={handlePsItemChange} handleChartTypeChange={handleChartTypeChange} removeItem={removeItem}/>: '' }

          <HighchartsReact
              className="HighChart"
              // callback={this.setChart}
              containerProps={{ style: { width: "100%", height: "100%" } }}
              highcharts={Highcharts}
              options={{
                  chart: {backgroundColor: "rgba(255,255,255, 0.1)",type:chartType},
                  title: {text: title, style: { color: "white" },},
                  subtitle: {text: titleSensor+" :: "+titlePsItem, style: { color: "white" },},
                  xAxis: {type: "datetime", accessibility: {rangeDescription: ""}},
                  yAxis: {title: {text:  unit, style: { color: "white" }}},
                  tooltip: {crosshairs: true, shared: true, valueSuffix: " " + unit},
                  series: [{
                      name:  titlePsItem,
                      data: averages,
                      zIndex: 1,
                      marker: {
                          fillColor: "white",
                          lineWidth: 2,
                          lineColor: Highcharts.getOptions().colors[0],
                      },
                  },
                      {
                          name: "Range",
                          data: ranges,
                          type: "arearange",
                          lineWidth: 0,
                          linkedTo: ":previous",
                          color: Highcharts.getOptions().colors[0],
                          fillOpacity: 0.3,
                          zIndex: 0,
                          marker: {
                              enabled: false,
                          },
                      },
                  ],
              }}
          />
       </>

  );
};

export default FxLineChart;
